import { PaymentProduct, Touchpoint } from "../../api/public/subscription-api";

export enum PaywallState {
  open = 'open',
  closed = 'closed'
}

export type PaywallArguments = {
  touchpoint: Touchpoint;
  props: { [key: string]: string; };
  styles?: PaywallExternalStyles;
};

export type PaywallCallbacks = {
  onOpen?: () => void;
  onClose?: (method?: 'back' | 'x') => void;
  onPaymentInitialize?: (product: PaymentProduct, paymentMethod: PaymentMethods) => void;
  onSubscribe?: (product: PaymentProduct) => void;
  onCountdownEnd?: () => void;
  onError?: () => void;
  onInteract?: (interaction?: string) => void;
};

export enum PaywallNavigationPage {
  paywall = 'paywall',
  checkout = 'checkout',
  congrats = 'congrats'
}

export type PaywallNavigation = {
  page: PaywallNavigationPage;
  step: string;
};

export type PaywallExternalStyles = {
  container?: React.CSSProperties;
  header?: React.CSSProperties;
  inner?: React.CSSProperties;
  body?: React.CSSProperties;
  loaderContainer?: React.CSSProperties;
  loader?: React.CSSProperties;
};

export enum PaymentMethods {
  applePay = 'applePay',
  googlePay = 'googlePay',
  payPal = 'payPal',
  card = 'card',
  vtb = 'vtb'
};

export type PaymentMethodItem = {
  method: PaymentMethods;
  title: string;
  icon: React.ReactElement;
  order: number;
};

export enum LongPaywallProductNames {
  proMonthlyNoTrial = 'pro-monthly-no-trial',

  proAnnualTrial = 'pro-annual-trial',
  proAnnualNoTrial = 'pro-annual-no-trial',

  maxAnnualTrial = 'max-annual-trial',
  maxAnnualNoTrial = 'max-annual-no-trial',

  sololearnAiOneWeek = 'sololearn-ai-one-week',
  sololearnAiFourWeeks = 'sololearn-ai-four-weeks',
  sololearnAiTwelveWeeks = 'sololearn-ai-twelve-weeks'
}

export type LongPaywallProductMeta = {
  name: LongPaywallProductNames;
  key: string;
  originalPrice: number;
  discount?: number;
  discountedPrice?: number;
  priceSuffix: string;
  billingInfo: string;
  billingNotice: string;
  features: string[];
  cta: string;
  tag: string;
  secondaryTag: string;
  period: number;
  currency?: 'USD' | 'RUB';
  paymentProvider?: 'vtb' | 'braintree';
};

export type LongPaywallProduct = {
  meta: LongPaywallProductMeta;
  product: PaymentProduct;
};

export type WTAPaywallV2ProductMeta = {
  key: string;
  name: string;
  label: {
    text: string;
    icon: string;
    theme: 'purple' | 'green' | 'yellow' | 'blue';
  };
  badge: string;
  originalPrice: number;
  billingCycleInfo: string;
  priceType?: 'full' | 'perDay';
  dailyPrice?: number;
};

export type WTAPaywallV2Product = {
  meta: WTAPaywallV2ProductMeta;
  product: PaymentProduct;
};

export const CardFields = ['number', 'cvv', 'expirationDate', 'postalCode'];

export class PaywallErroredData { }

export const PaywallOfferModalId = 'PaywallOfferModalId';

export enum PaywallClickTypes {
  close = 'CLOSE',
  cta = 'CTA',
  freeBlock = 'FREE_BLOCK',
  monthlyBlock = 'MONTHLY_BLOCK',
  annualBlock = 'ANNUAL_BLOCK',
  quarterlyBlock = 'QUARTERLY_BLOCK',
  faqItem = 'FAQ_ITEM',
  moneyBackGuaranteeLink = 'MONEY_BACK_GUARANTEE_LINK',
  paymentMethod = 'PAYMENT_METHOD',
  productChange = 'PRODUCT_CHANGE',
  subscribe = 'SUBSCRIBE'
}